export const reasonDescriptionMapping = {
  "Before timeframe start":
    "The order was placed on the same day as the filtered start time, but before the time",
  "After timeframe end":
    "The order was placed on the same day as the filtered end time, but after the time",
  "During experiment pause":
    "The order was placed while the experiment was paused",
  "Subscription refill":
    "The order is a subscription refill (i.e., not the first order in the subscription series)",
  "Draft order": "The order is a Shopify draft order",
  "Non-online store order":
    "The order originated from a channel outside of the Shopify online store (e.g., Shopify POS, Instagram Shopping, etc.)",
  "Visitor is a bot or crawler":
    "The visitor who placed this order is excluded because they are a bot or web crawler",
  "Visitor has opened Intelligems preview mode":
    "The visitor who placed this order is excluded because they have opened Intelligems' preview mode before",
  "Visitor never entered the experiment":
    "The visitor who placed this order never entered this experiment (e.g., they never visited a targeted page, or never went through a redirect in a redirect test, etc.)",
  "Visitor was excluded from the experiment by audience targeting":
    "The visitor who placed this order is excluded by audience targeting",
  "Visitor was excluded from analytics by audience targeting":
    "The visitor who placed this order is excluded from analytics by audience targeting",
  "Visitor never visited the redirect page":
    "The visitor who placed this order visitor never went through an experiment redirect",
  "Visitor did not visit during the selected timeframe":
    "The visitor who placed this order did not visit the store during the selected timeframe",
  "Associated test group has been deleted":
    "The test group this visitor was placed into has been deleted",
  "Net revenue is <= $0": "The order's net revenue is $0 or less",
  "No Intelligems ID": "There is no Intelligems ID noted on the order.",
  "No page views": "There are no page views recorded for this visitor.",
  "Filtered out: no experiment products":
    "The order is filtered out because it did not contain any experiment products",
  "Filtered out: outlier":
    "The order is filtered out because it is an outlier in net revenue",
  "Filtered out: device type":
    "The order is filtered out by the device type filter",
  "Filtered out: channel": "The order is filtered out by the channel filter",
  "Filtered out: new vs. returning visitor":
    "The order is filtered out by the new vs. returning visitor filter",
  "Filtered out: custom event":
    "The order is filtered out by the custom event filter",
  "Filtered out: country": "The order is filtered out by the country filter",
  "Filtered out: added to cart filter":
    "The order is filtered out by the added to cart filter",
  "Filtered out: started checkout filter":
    "The order is filtered out by the started checkout filter",
  "Not excluded": "The order is included in experiment analytics",
};
